import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/parameters"
import { useNavigate, useParams } from 'react-router-dom';
import { ParameterTypeSelect } from "../../ui/myselect";

export default function ParametersEdit() {

  const [type, setType] = useState();
  const [parameter, setParameter] = useState();
  const [order, setOrder] = useState(0);
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();
  let { slug } = useParams();


  async function GetData(id) {
    const parameterData = await getIdData(slug);
    console.log("parameterData", parameterData[0]);
    setData(parameterData);
    setType(parameterData[0].type);
    setParameter(parameterData[0].pname);
    setOrder(parameterData[0].order);
    setIsActive(parameterData[0].isActive);
  }

  const handleSubmit = async (e) => {
      e.preventDefault();
/*
      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      console.log("formJson",formJson);
  */
    if (slug === "Add") {
      console.log("Add");
      await addData({
        pname: parameter,
        type: type,
        order: order,
        isActive : isActive        
      });
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        pname: parameter,
        type: type,
        order: order,
        isActive : isActive
      });
    }

    navigate("/admin/admin-params");
  
  };

  useEffect(() => {
    //navigate("/admin-params");
    if (slug !== "Add") {
      GetData(slug);
    }
  }, [slug])
  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-2">
                  <div className="profile-heading p-2">
                    <h3>{slug === "Add" ? "Add Parameter" : "Update Parameter" }</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form method="post"  onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Type
                            </label>
                            {/*}
                            <input
                              type="text"
                              name = "type"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                              className="form-control"
                              placeholder="Enter Type"
                              required
                            />
                            */}
                             <ParameterTypeSelect value={type} setValue={setType} />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">Parameter</label>
                            <input
                              type="text"
                              name = "parameter"
                              value={parameter}
                              onChange={(e) => setParameter(e.target.value)}
                              className="form-control"
                              placeholder="Enter Parameter"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Order
                            </label>
                            <input
                              type="number"
                              name="order"
                              value={order}
                              onChange={(e) => setOrder(e.target.value)}
                              className="form-control"
                              placeholder="Order"
                            />
                          </div>
                        </div>
                        <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Is Active</label>
                    <div className="form-check form-switch check-on">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) => setIsActive(!isActive)}
                      />
                    </div>
                  </div>
                </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            {slug === "Add" ? "Add Parameter" : "Update Parameter" }
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
